import { withStyles } from '@material-ui/core';
const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 340,
    marginTop: 18
  },
  title: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    color: theme.iconColor
  },
  titleLink: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 500,
    color: theme.HeaderSelectedText,
    textDecorationLine: 'underline',
    lineHeight: '24px',
    cursor: 'pointer'
  }
});

const NewHolidayInfo = (props) => {
  const { classes, onClick } = props;
  return (
    <div className={classes.container}>
      <span className={classes.title}>
        To add a new holiday please visit 'Holiday Management' tab user settings.
      </span>
      <span className={classes.titleLink} onClick={onClick}>
        Visit Holiday Management
      </span>
    </div>
  );
};

export default withStyles(styles)(NewHolidayInfo);
